import uluwantuBali from '../../../media/about/abroad/Uluwantu_Bali.jpeg';
import barcelona from '../../../media/about/abroad/barcelona.jpeg';
import barcelonaStadium from '../../../media/about/abroad/barcelona_stadium.jpeg';
import barcelonaSunsetView from '../../../media/about/abroad/barcelona_sunset_view.jpeg';
import bigBen from '../../../media/about/abroad/big_ben.jpeg';
import budapest from '../../../media/about/abroad/budapest.jpeg';
import eiffelTower from '../../../media/about/abroad/eiffel_tower.jpeg';
import hongKong from '../../../media/about/abroad/hong_kong.jpeg';
import hongKongStreet from '../../../media/about/abroad/hong_kong_street.jpeg';
import monacoHarbor from '../../../media/about/abroad/monaco_harbor.jpeg';
import moroccoCamp from '../../../media/about/abroad/morocco_camp.jpeg';
import moroccoDesert from '../../../media/about/abroad/morrocoo_desert.jpeg';
import niceFrance from '../../../media/about/abroad/nice_france.jpeg';
import norway from '../../../media/about/abroad/norway.jpeg';
import oliviaSpain from '../../../media/about/abroad/olivia_spain.jpeg';
import parisCafeChess from '../../../media/about/abroad/paris_cafe_chess.jpeg';
import parkGruel from '../../../media/about/abroad/park_gruel.jpeg';
import richmondEngland from '../../../media/about/abroad/richmond_england.jpeg';
import sagradaFamilia from '../../../media/about/abroad/sagrada_familia.jpeg';
import swissAlps from '../../../media/about/abroad/swiss_alps.jpeg';
import londonSoho from '../../../media/about/abroad/soho_london.jpeg';
import streetBarcelona from '../../../media/about/abroad/street_barcelona.jpeg';

const abroadStory = {
  id: "abroad",
  title: "Abroad 2025",
  heroImage: streetBarcelona,
  gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",

  description: `During my spring semester of 2025, I studied in Barcelona, Spain. The idea of living abroad was always appealing to me and when presented with the opportunity, I jumped in!  As Spain was my home base during that semester, I embraced the ease of travel and was able to explore nearby countries such as Switzerland, Hungary, Norway, Morocco, Monaco, France and England; finishing the journey in China and Indonesia with my brother and father.`,

  gallery: [
    { type: 'image', src: barcelona, alt: 'Barcelona cityscape' },
    { type: 'image', src: sagradaFamilia, alt: 'Sagrada Familia' },
    { type: 'image', src: barcelonaStadium, alt: 'Barcelona stadium' },
    { type: 'image', src: barcelonaSunsetView, alt: 'Barcelona sunset view' },
    { type: 'image', src: eiffelTower, alt: 'Eiffel Tower in Paris' },
    { type: 'image', src: parisCafeChess, alt: 'Playing chess at a Paris café' },
    { type: 'image', src: parkGruel, alt: 'Park Güell' },
    { type: 'image', src: hongKong, alt: 'Hong Kong skyline' },
    { type: 'image', src: hongKongStreet, alt: 'Hong Kong street scene' },
    { type: 'image', src: moroccoDesert, alt: 'Moroccan desert' },
    { type: 'image', src: moroccoCamp, alt: 'Desert camp in Morocco' },
    { type: 'image', src: swissAlps, alt: 'Swiss Alps' },
    { type: 'image', src: norway, alt: 'Norway ski mountaintop' },
    { type: 'image', src: budapest, alt: 'Budapest' },
    { type: 'image', src: monacoHarbor, alt: 'Monaco harbor' },
    { type: 'image', src: niceFrance, alt: 'Nice, France' },
    { type: 'image', src: uluwantuBali, alt: 'Uluwatu, Bali' },
    { type: 'image', src: bigBen, alt: 'Big Ben in London' },
    { type: 'image', src: richmondEngland, alt: 'Richmond, England' },
    { type: 'image', src: oliviaSpain, alt: 'Oliva, Spain' },
    { type: 'image', src: londonSoho, alt: 'Soho, London' }
  ]
};

export default abroadStory;
